import { useQuery } from 'react-query';

import APIs from '../api';
import { useAppDispatch, useAppSelector } from '../reducer/hooks';
import { AssetInfos, selectAssetInfos, setAssetInfoList } from '../reducer/assetInfosSlice';

interface IProps {
  shouldFetch?: boolean;
}

const useAssetInfosList = (props: IProps = {}) => {
  const { shouldFetch } = props;
  const isFetchEnabled = shouldFetch === true;

  const dispatch = useAppDispatch();
  const { list: assetInfosList } = useAppSelector(selectAssetInfos);

  const handleQuery = async () => {
    const res = await APIs.Query.getAssetInfosQuery();
    return res;
  };

  useQuery(['assetInfosList'], handleQuery, {
    onSuccess: (data: AssetInfos) => {
      dispatch(setAssetInfoList(data));
    },
    enabled: isFetchEnabled,
  });

  const getAssetInfo = (chainName: string, address: string) => {
    return assetInfosList?.[chainName]?.[address] || {};
  };

  return {
    assetInfosList,
    getAssetInfo,
  };
};

export default useAssetInfosList;
